import { v4 as uuidv4 } from 'uuid';
import { type PayloadAction, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { type DialogProps } from '@mui/material';

export type StyledDialogComponentProps = DialogProps & { fullHeight?: boolean };

type DialogComponentProps = Omit<StyledDialogComponentProps, 'open'>;

interface DialogState {
	id: string;
	state: boolean;
	options: DialogComponentProps;
}

const dialogsAdapter = createEntityAdapter({
	selectId: (dialog: DialogState) => dialog.id
});
const initialState = dialogsAdapter.getInitialState();

export const { selectAll: selectDialogs, selectById: selectDialogsById } = dialogsAdapter.getSelectors(
	(state: any) => state.dialogs
);

const dialogSlice = createSlice({
	name: 'dialogs',
	initialState,
	reducers: {
		openDialog: (state, action: PayloadAction<DialogComponentProps>) => {
			return dialogsAdapter.addOne(state, { id: uuidv4(), state: true, options: action.payload });
		},
		closeDialog: state => {
			return dialogsAdapter.removeOne(state, state.ids[state.ids.length - 1]);
		},
		closeDialogById: (state, action: PayloadAction<string>) => {
			return dialogsAdapter.removeOne(state, action.payload);
		}
	}
});

export const { openDialog, closeDialog, closeDialogById } = dialogSlice.actions;

export default dialogSlice.reducer;
